const FACEBOOK_ACTION_BUTTON_CTA_SOURCE = 'facebook-action-button';
const INSTAGRAM_ACTION_BUTTON_CTA_SOURCE = 'instagram-action-button';
const GOOGLE_ORDERING_REDIRECT_SOURCE = 'google-ordering';

const WELCOME_CAMPAIGN_SOURCE = 'welcome-camp';
const WELCOME_CAMPAIGN_SOURCE_SMS = 'welcome-camp_s';
const WELCOME_CAMPAIGN_SOURCE_MMS = 'welcome-camp_m';
const WELCOME_CAMPAIGN_REMINDER_SOURCE = 'welcome-campr';
const WELCOME_CAMPAIGN_REMINDER_SOURCE_SMS = 'welcome-campr_s';
const WELCOME_CAMPAIGN_REMINDER_SOURCE_MMS = 'welcome-campr_m';
const THIRTY_DAY_CAMPAIGN_SOURCE = '30-camp';
const THIRTY_DAY_CAMPAIGN_SOURCE_SMS = '30-camp_s';
const THIRTY_DAY_CAMPAIGN_SOURCE_MMS = '30-camp_m';
const THIRTY_DAY_CAMPAIGN_REMINDER_SOURCE = '30-campr';
const THIRTY_DAY_CAMPAIGN_REMINDER_SOURCE_SMS = '30-campr_s';
const THIRTY_DAY_CAMPAIGN_REMINDER_SOURCE_MMS = '30-campr_m';
const SIXTY_DAY_CAMPAIGN_SOURCE = '60-camp';
const SIXTY_DAY_CAMPAIGN_SOURCE_SMS = '60-camp_s';
const SIXTY_DAY_CAMPAIGN_SOURCE_MMS = '60-camp_m';
const SIXTY_DAY_CAMPAIGN_REMINDER_SOURCE = '60-campr';
const SIXTY_DAY_CAMPAIGN_REMINDER_SOURCE_SMS = '60-campr_s';
const SIXTY_DAY_CAMPAIGN_REMINDER_SOURCE_MMS = '60-campr_m';
const REORDER_CATERING = 'cat-reorder';
const REORDER_CATERING_MMS = 'cat-reorder-m';
const REORDER_CATERING_SMS = 'cat-reorder-s';
const REORDER_CATERING_EMAIL = 'cat-reorder-e';
const EMAIL_CAMPAIGN_REFERRAL_SOURCE = 'email-campaign';
const SMS_CAMPAIGN_REFERRAL_SOURCE = 'sms-campaign';
const REORDER_CATERING_THIRTY_DAYS = '30day-cater-reorder';
const REORDER_CATERING_THIRTY_DAYS_SMS = '30day-cater-reorder_s';
const REORDER_CATERING_THIRTY_DAYS_MMS = '30day-cater-reorder_m';
const REORDER_CATERING_THIRTY_DAYS_EMAIL = '30day-cater-reorder_e';

export const REFERRAL_SOURCES_FOR_META = [
  FACEBOOK_ACTION_BUTTON_CTA_SOURCE,
  INSTAGRAM_ACTION_BUTTON_CTA_SOURCE
];

export const REFERRAL_SOURCES = [
  ...REFERRAL_SOURCES_FOR_META,
  WELCOME_CAMPAIGN_SOURCE,
  WELCOME_CAMPAIGN_SOURCE_SMS,
  WELCOME_CAMPAIGN_SOURCE_MMS,
  WELCOME_CAMPAIGN_REMINDER_SOURCE,
  WELCOME_CAMPAIGN_REMINDER_SOURCE_SMS,
  WELCOME_CAMPAIGN_REMINDER_SOURCE_MMS,
  THIRTY_DAY_CAMPAIGN_SOURCE,
  THIRTY_DAY_CAMPAIGN_SOURCE_SMS,
  THIRTY_DAY_CAMPAIGN_SOURCE_MMS,
  THIRTY_DAY_CAMPAIGN_REMINDER_SOURCE,
  THIRTY_DAY_CAMPAIGN_REMINDER_SOURCE_SMS,
  THIRTY_DAY_CAMPAIGN_REMINDER_SOURCE_MMS,
  SIXTY_DAY_CAMPAIGN_SOURCE,
  SIXTY_DAY_CAMPAIGN_SOURCE_SMS,
  SIXTY_DAY_CAMPAIGN_SOURCE_MMS,
  SIXTY_DAY_CAMPAIGN_REMINDER_SOURCE,
  SIXTY_DAY_CAMPAIGN_REMINDER_SOURCE_SMS,
  SIXTY_DAY_CAMPAIGN_REMINDER_SOURCE_MMS,
  REORDER_CATERING,
  REORDER_CATERING_MMS,
  REORDER_CATERING_SMS,
  REORDER_CATERING_EMAIL,
  EMAIL_CAMPAIGN_REFERRAL_SOURCE,
  REORDER_CATERING_THIRTY_DAYS,
  REORDER_CATERING_THIRTY_DAYS_SMS,
  REORDER_CATERING_THIRTY_DAYS_MMS,
  REORDER_CATERING_THIRTY_DAYS_EMAIL,
  SMS_CAMPAIGN_REFERRAL_SOURCE,
  GOOGLE_ORDERING_REDIRECT_SOURCE
];
